import request from "../Frontends/Common/utils/request/requestMain";
const rootRoute = "scheduler/tasktype/";

export default class TaskTypeApi {
  async get() {
    return await request.post(`${rootRoute}gettasktypes`, {});
  }
}
